/* ============================================================
   Wyld Chics — infinite scroll on collection pages
   assets/wc-scroll.js   (replaces the Scroll Bee app, 2026-09-13)

   What the app did, measured on the live site: hide the theme's
   pagination, watch the last product, and when it comes into view fetch
   `?page=N` and append that page's tiles to the grid (24 per page here),
   with a short loading state (500ms minimum). No URL change.

   Same here, theme-native:
     - the section is fetched with `section_id` so only this grid renders
     - new <li> tiles are adopted into the existing <ul>; Alpine picks up
       their islands (quick buy, Notify me) on its own
     - the hidden pagination is swapped for the fetched one, so the next
       link keeps advancing until there is none
     - the theme's filter/sort island replaces #facets-filterable's
       innerHTML on every change; a MutationObserver re-binds after it
     - a Load more button is the fallback when the fetch fails or
       IntersectionObserver is missing
   ============================================================ */
(function () {
  'use strict';

  var MIN_LOADING = 450;
  var loading = false, done = false, io = null, gen = 0;

  function root() { return document.getElementById('facets-filterable'); }
  function grid() { var r = document.getElementById('facets-results'); return r && r.querySelector('ul'); }
  function nav() { var r = root(); return r && r.querySelector('nav.pagination'); }
  function nextUrl() { var n = nav(); var a = n && n.querySelector('a[rel="next"]'); return a ? a.getAttribute('href') : null; }
  function sectionId() {
    var r = root(); var s = r && r.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  function ensureSentinel() {
    var r = root(); if (!r) return null;
    var el = r.querySelector('[data-wc-scroll]');
    if (el) return el;
    var results = document.getElementById('facets-results');
    if (!results) return null;
    el = document.createElement('div');
    el.className = 'wc-scroll';
    el.setAttribute('data-wc-scroll', '');
    el.innerHTML =
      '<div class="wc-scroll__loader" data-wc-scroll-loader hidden aria-live="polite"><span></span><span></span><span></span><span class="sr-only"></span></div>' +
      '<button type="button" class="wc-scroll__more" data-wc-scroll-more hidden></button>';
    // words from the locale (window.theme.strings, snippets/js-bridge.liquid), English if missing
    var S = (window.theme && window.theme.strings) || {};
    el.querySelector('[data-wc-scroll-loader] .sr-only').textContent = S.wcLoadingMore || 'Loading more';
    el.querySelector('[data-wc-scroll-more]').textContent = S.wcLoadMore || 'Load more';
    results.insertAdjacentElement('afterend', el);
    return el;
  }

  function hidePagination() {
    var n = nav(); if (!n) return;
    var wrap = n.parentElement && n.parentElement.classList.contains('mt-10') ? n.parentElement : n;
    wrap.classList.add('wc-scroll-hidden');
  }

  function loadNext() {
    if (loading || done) return;
    var url = nextUrl();
    var sid = sectionId();
    var ul = grid();
    var sentinel = ensureSentinel();
    if (!url || !sid || !ul || !sentinel) { done = true; if (sentinel) sentinel.hidden = true; return; }
    loading = true;
    var myGen = gen;                 // the grid can be replaced by a filter change mid-fetch
    var loader = sentinel.querySelector('[data-wc-scroll-loader]');
    var more = sentinel.querySelector('[data-wc-scroll-more]');
    loader.hidden = false; more.hidden = true;
    var started = Date.now();
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#facets-results > ul > li');
        var newNav = doc.querySelector('nav.pagination');
        var wait = Math.max(0, MIN_LOADING - (Date.now() - started));
        return new Promise(function (res) { setTimeout(res, wait); }).then(function () {
          if (myGen !== gen) return;   // stale: a filter or sort replaced the grid meanwhile
          var frag = document.createDocumentFragment();
          items.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
          ul.appendChild(frag);
          if (window.initTeleport) window.initTeleport(ul);
          var oldNav = nav();
          if (newNav && oldNav) oldNav.replaceWith(document.adoptNode(newNav));
          else if (oldNav) oldNav.remove();
          hidePagination();
          if (!nextUrl()) { done = true; sentinel.hidden = true; }
          document.dispatchEvent(new CustomEvent('wc:scroll:loaded', { detail: { count: items.length } }));
        });
      })
      .catch(function (err) {
        if (window.console) console.warn('[wc-scroll]', err && err.message);
        more.hidden = false;           // let them try by hand
      })
      .then(function () { loader.hidden = true; loading = false; if (myGen !== gen) loadNext(); });
  }

  /* bind() runs on load and after every replacement of #facets-filterable.
     Inserting the sentinel is itself a mutation, so it also runs on its own
     insert: it must never reset `loading`, or a fetch in flight gets a twin
     (page 2 landed twice, 24 + 14 + 14, caught 2026-09-13). */
  function bind() {
    var r = root(); if (!r) return;
    if (r.querySelector('[data-wc-scroll]')) {
      if (!nextUrl()) { done = true; r.querySelector('[data-wc-scroll]').hidden = true; }
      return;                        // still the same grid, nothing to rebind
    }
    gen += 1; done = false;
    var sentinel = ensureSentinel();
    if (!sentinel) return;
    hidePagination();
    if (!nextUrl()) { done = true; sentinel.hidden = true; return; }
    sentinel.hidden = false;
    if (io) io.disconnect();
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadNext();
      }, { rootMargin: '600px 0px' });   // start fetching well before the bottom, like the app
      io.observe(sentinel);
    } else {
      sentinel.querySelector('[data-wc-scroll-more]').hidden = false;
    }
  }

  document.addEventListener('click', function (evt) {
    var b = evt.target && evt.target.closest && evt.target.closest('[data-wc-scroll-more]');
    if (b) { evt.preventDefault(); loadNext(); }
  });

  function start() {
    var r = root(); if (!r) return;
    bind();
    // the filter island swaps this container's children on every filter/sort change
    new MutationObserver(function () { setTimeout(bind, 50); }).observe(r, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
